<template>
  <div>
    <v-item-group v-model="pickedPlan" class="plans_container" mandatory>
      <div class="d-flex justify-space-between">
        <v-item #default="{ active, toggle }" value="creator">
          <v-tooltip top :disabled="currentPlan !== 'advanced'">
            <template #activator="{ on }">
              <v-card
                v-on="on"
                :ripple="false"
                class="plan_card"
                v-bind="cardCommonAttrs"
                :color="active ? 'active' : null"
                @click="toggle"
              >
                <SizeBox height="24" />
                <v-card-text
                  class="d-flex flex-column align-center"
                  style="position: relative; z-index: 2"
                >
                  <p class="text-h6 mb-1" style="color: #ffffff">
                    {{ $t('PLAN.WORD.CREATOR_PLAN') }}
                  </p>
                  <p class="text-12px">
                    {{ $t('PLAN.COPYWRITING.BEST_FOR_PERSONAL_CREATOR') }}
                  </p>

                  <p class="text-h6 success--text">
                    NTD$
                    <span class="text-h4 font-weight-bold">
                      {{ 3000 | currency }}
                    </span>
                    / {{ $t('PLAN.WORD.MONTH') }}
                  </p>

                  <v-btn
                    :color="active ? 'primary' : null"
                    :outlined="!active"
                    :disabled="currentPlan === 'advanced'"
                    depressed
                    class="w80p"
                    @click="currentPlan !== 'advanced' && $emit('next')"
                  >
                    {{ $t('PLAN.WORD.INQUIRY') }}
                  </v-btn>

                  <div class="detail">
                    <p class="primary--text btn">
                      {{ $t('PLAN.COPYWRITING.MAXIMUM_CREATE') }} 5
                      {{ $t('PLAN.WORD.MEASURE_EXH') }}
                    </p>
                    <p>
                      {{ $t('PLAN.COPYWRITING.CAN_CREATE_UP') }} 3
                      {{ $t('PLAN.WORD.MEASURE_EXH') }}
                    </p>
                    <p>
                      {{ $t('PLAN.COPYWRITING.THEMES_THAT_SUPPORT_50+_ITEMS') }}
                    </p>
                    <p>
                      {{ $t('PLAN.COPYWRITING.STAGE_3D_MODEL_IRREPLACABLE') }}
                    </p>
                    <p class="primary--text btn">
                      {{ $t('PLAN.COPYWRITING.ZERO_ADS') }}
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </template>
            <span>
              {{
                $t('PLAN.COPYWRITING.YOU_HAD_ALREADY_PURCHASED_ADVANCE_PLAN')
              }}
            </span>
          </v-tooltip>
        </v-item>

        <v-item #default="{ active, toggle }" value="advanced">
          <v-card
            v-bind="cardCommonAttrs"
            :color="active ? 'active' : null"
            @click="toggle"
            class="plan_card advanced"
          >
            <SizeBox height="24" />
            <v-card-text
              class="d-flex flex-column align-center"
              style="position: relative; z-index: 2"
            >
              <p class="text-h6 mb-1" style="color: #ffffff">
                {{ $t('PLAN.WORD.ADVANCE_PLAN') }}
              </p>
              <p class="text-12px">
                {{ $t('PLAN.COPYWRITING.BEST_FOR_BUSINESS_CURATOR') }}
              </p>

              <p class="text-h6 success--text">
                NTD$
                <span class="text-h4 font-weight-bold">
                  {{ 22000 | currency }}
                </span>
                / {{ $t('PLAN.WORD.MONTH') }}
              </p>

              <v-btn
                :color="active ? 'primary' : null"
                :outlined="!active"
                depressed
                class="w80p"
                @click="$emit('next')"
              >
                {{ $t('PLAN.WORD.INQUIRY') }}
              </v-btn>
              <div class="detail">
                <p class="primary--text btn">
                  {{ $t('PLAN.COPYWRITING.CAN_PUBLISH_UP') }} 10
                  {{ $t('PLAN.WORD.MEASURE_EXH') }}!
                </p>
                <p>
                  {{ $t('PLAN.COPYWRITING.MAXIMUM_CREATE') }} 15
                  {{ $t('PLAN.WORD.MEASURE_EXH') }}
                </p>
                <p>
                  {{ $t('PLAN.COPYWRITING.THEMES_THAT_SUPPORT_50+_ITEMS') }}
                </p>
                <p>{{ $t('PLAN.COPYWRITING.EXCLUSIVE_THEME_INCLUDED') }}</p>
                <p>{{ $t('PLAN.COPYWRITING.STAGE_3D_MODEL_REPLACABLE') }}</p>
                <p class="primary--text btn">
                  {{ $t('PLAN.COPYWRITING.ZERO_ADS') }}
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-item>

        <v-item #default="{ active, toggle }" value="custom">
          <v-card
            v-bind="cardCommonAttrs"
            :color="active ? 'active' : null"
            :ripple="false"
            @click="toggle"
            class="plan_card"
          >
            <SizeBox height="24" />
            <v-card-text
              class="flex-center flex-column"
              style="position: relative; z-index: 2"
            >
              <p class="text-h6 mb-1" style="color: #ffffff">
                {{ $t('PLAN.WORD.CUSTOMIZED_SOLUTION') }}
              </p>
              <p class="text-12">
                {{
                  $t(
                    'PLAN.COPYWRITING.CREATE_HIGH_QUALITY_UNIQUE_SPACE_FOR_YOUR_BRAND'
                  )
                }}
              </p>

              <p class="text-h6 success--text">
                <span class="text-h4 font-weight-bold">
                  {{ $t('PLAN.WORD.CONTACT_US') }}
                </span>
              </p>

              <v-btn
                :color="active ? 'primary' : null"
                :outlined="!active"
                href="https://docs.google.com/forms/d/e/1FAIpQLSdcxcP2VKi2I2oxQ6JLPnLBlg8zUTTaYslq00SuCRHqkHoekQ/viewform"
                target="_blank"
                depressed
                class="w80p"
              >
                {{ $t('PLAN.WORD.CONTACT_US') }}
              </v-btn>

              <div class="detail">
                <div>
                  {{ $t('PLAN.COPYWRITING.3D_IMMERSIVE_DESIGN') }}
                  <br />
                  {{ $t('PLAN.COPYWRITING.TAILOR-MADE') }}
                </div>
                <div>
                  <span style="font-weight: 700">
                    {{ $t('PLAN.WORD.OUR_CLIENTS') }}
                  </span>
                  <br />
                  {{
                    $t(
                      'PLAN.COPYWRITING.DAZS_ARTIST_NINE_CHEN_PAULAS_CHOICE_TAITRA_GLENROTHES'
                    )
                  }}
                </div>
                <div class="flex-center flex-column">
                  <p>
                    {{ $t('PLAN.COPYWRITING.EXPLORE_MORE') }}
                    <span
                      class="primary--text btn"
                      @click="toUrl('https://bkhole.com/bk-portfolio/')"
                    >
                      {{ $t('PLAN.COPYWRITING.EXH_EXAMPLE') }}
                    </span>
                  </p>
                  <p>
                    {{ $t('PLAN.COPYWRITING.EXPLORE_MORE') }}
                    <span
                      class="primary--text btn"
                      @click="
                        toUrl(
                          'https://docs.google.com/forms/d/e/1FAIpQLSdcxcP2VKi2I2oxQ6JLPnLBlg8zUTTaYslq00SuCRHqkHoekQ/viewform'
                        )
                      "
                    >
                      {{ $t('PLAN.COPYWRITING.OUR_SERVICE') }}
                    </span>
                  </p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-item>
      </div>
    </v-item-group>

    <SizeBox height="48" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      pickedPlan: ''
    };
  },

  computed: {
    ...mapGetters({
      Team: 'auth/getTeam'
    }),
    cardCommonAttrs() {
      return {
        width: this.$vuetify.breakpoint.mdAndDown ? 260 : 288,
        elevation: 0,
        class: 'b-rad-20 pa-2 overflow-hidden'
      };
    },
    currentPlan() {
      return this?.Team?.permissionAsset?.teamGroup?.alias;
    },
    canGoNext() {
      return !!this.pickedPlan && this.pickedPlan !== 'custom';
    }
  },
  methods: {
    toUrl(url) {
      window.open(url);
    }
  },
  watch: {
    pickedPlan(val) {
      this.$emit('pick', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.big-num {
  font-size: 24px;
  font-weight: bold;
}
.v-card--link:focus:before {
  display: none;
}
.plan_card {
  background-color: var(--color-neutral800);
  &.advanced {
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      background: linear-gradient(75deg, #ff65e6, #00b6f0);
      display: block;
      position: absolute;
      opacity: 1;
      transition: all 0.5s ease-in-out;
    }
    &:after {
      content: '';
      width: calc(100% - 8px);
      height: calc(100% - 8px);
      background: $neutral800;
      display: block;
      position: absolute;
      opacity: 1;
      left: 4px;
      top: 4px;
      border-radius: 16px;
    }
  }
  button,
  a {
    width: 140px;
    margin-bottom: 56px;
  }
  .detail {
    padding: 40px 12px;
    border-top: 1px solid $neutral600;
    text-align: center;
    p,
    > div {
      margin-bottom: 20px;
      color: $neutral200;
    }
  }
}
</style>